import { checkoutOptimizationStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const getCheckoutTreeFlowStepsById = {
  name: "getCheckoutTreeFlowStepsById" as const,
  input: z.object({ checkoutTreeId: z.string() }),
  output: z.object({
    steps: checkoutOptimizationStepArraySchema,
    isActive: z.boolean(),
    label: z.string(),
  }),
};

export type GetCheckoutTreeFlowStepsByIdOutput = z.infer<
  typeof getCheckoutTreeFlowStepsById.output
>;
